import React, { useEffect } from "react";
import logo from "../../image/learningportal.svg";
import { useDispatch, useSelector } from "react-redux";
import { userLoggedOut } from "../../features/AuthApi/authSlice";
import { Link, useParams } from "react-router-dom";
import { useGetQuizzesQuery } from "../../features/QuizzesApi";
import { useGetOneVideoQuery } from "../../features/Videos/VideosApi";
const Quiz = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const logout = () => {
    localStorage.removeItem("auth");
    dispatch(userLoggedOut());
  };
  useEffect(() => {
    document.title = "Quiz";
  });
  const { id } = useParams();
  const { data: quizzes } = useGetQuizzesQuery() || {};

  const { data: video } = useGetOneVideoQuery(id) || {};

  const filteredQuizzes = quizzes?.filter(
    (elm) => elm?.video_id === Number(id)
  );

  return (
    <div>
      {/* <!-- Navigatin Bar. It contains Logo, Center Text And Save Progress Button at the end --> */}
      <nav className="shadow-md">
        <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
          <img className="h-10" src={logo} alt="logo" />
          <div className="flex items-center gap-3">
            <Link to="/courseplayer">
              <h2 className="font-medium">{auth?.user?.name}</h2>
            </Link>
            <button
              onClick={logout}
              className="flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                />
              </svg>
              Logout
            </button>
          </div>
        </div>
      </nav>

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="mb-8">
            <h1 className="text-2xl font-bold">Quizzes for "{video?.title}"</h1>
            <p className="text-sm text-slate-200">
              Each question contains 5 Mark
            </p>
          </div>
          <div className="space-y-8 ">
            {filteredQuizzes?.map((quiz, index) => (
              <div className="quiz">
                <h4 className="question">
                  Quiz {index + 1} - {quiz?.question}
                </h4>
                <form className="quizOptions">
                  {/* <!-- Option 1 --> */}
                  <label for={`option1${quiz?.options[0].option}`}>
                    <input
                      type="checkbox"
                      id={`option1${quiz?.options[0].option}`}
                    />
                    {quiz?.options[0].option}
                  </label>

                  {/* <!-- Option 2 --> */}
                  <label for={`option2${quiz?.options[1].option}`}>
                    <input
                      type="checkbox"
                      id={`option2${quiz?.options[1].option}`}
                    />
                    {quiz?.options[1].option}
                  </label>

                  {/* <!-- Option 3 --> */}
                  <label for={`option3${quiz?.options[2].option}`}>
                    <input
                      type="checkbox"
                      id={`option3${quiz?.options[2].option}`}
                    />
                    {quiz?.options[2].option}
                  </label>

                  {/* <!-- Option 4 --> */}
                  <label for={`option4${quiz?.options[3].option}`}>
                    <input
                      type="checkbox"
                      id={`option4${quiz?.options[3].option}`}
                    />
                    {quiz?.options[3].option}
                  </label>
                </form>
              </div>
            ))}
          </div>
          <Link to="/leaderboard">
            <button className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 ">
              Submit
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Quiz;
